<template>
  <v-flex class="referral-codes">
    <v-layout align-center>
      <h1>Referral Codes</h1>
      <v-spacer />
      <v-btn color="success" dark @click="generateDialog = true">
        Generate Code <v-icon right>add</v-icon>
      </v-btn>
    </v-layout>
    <v-card>
      <v-list v-if="loaded" two-line class="mt-3 pt-0 pb-0">
        <template v-for="(code, index) in referralCodes">
          <v-list-item :key="code.id">
            <v-layout align-center>
              <v-tooltip right :color="code.valid ? 'success' : 'error'">
                <template v-slot:activator="{ on }">
                  <v-icon
                    :color="code.valid ? 'success' : 'error'"
                    class="mr-3"
                    v-on="on"
                  >
                    {{ code.valid ? 'check' : 'close' }}
                  </v-icon>
                </template>
                <span v-if="code.valid">Code is valid</span>
                <span v-else>Code is invalid</span>
              </v-tooltip>
              {{ code.id }}
              <v-icon
                v-if="code.metadata.email"
                color="primary"
                class="ml-6 mr-2"
                >email</v-icon
              >
              {{ code.metadata.email }}
              <v-icon
                v-if="
                  code.metadata.first_name ||
                    code.metadata.last_name ||
                    code.metadata.name
                "
                color="primary"
                class="ml-6 mr-2"
                >person</v-icon
              >
              {{ getNameFromUser(code.metadata) }}
            </v-layout>
          </v-list-item>
          <v-divider
            v-if="index + 1 < referralCodes.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </v-card>
    <v-progress-linear
      v-if="!loaded"
      color="info"
      :indeterminate="true"
      class="mt-3"
    />

    <v-dialog v-model="generateDialog" persistent max-width="310">
      <v-card>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="valid && generateReferralCode()"
        >
          <v-app-bar flat dark color="primary">
            <v-toolbar-title>Are you sure?</v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-text-field
              v-model="email"
              label="Email*"
              :rules="[v => !!v || 'Email is required']"
              required
            />
            <v-text-field v-model="first_name" label="First Name" />
            <v-text-field v-model="last_name" label="Last Name" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="generateDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              color="success"
              :disabled="!valid"
              type="submit"
              :loading="loadingGenerate"
              >Generate</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { fbfunctions } from '@/firebaseConfig';
import getNameFromUser from '@/helpers/getNameFromUser.js';

export default {
  name: 'ReferralCodes',
  data() {
    return {
      generateDialog: false,
      loadingGenerate: false,
      referralCodes: [],
      loaded: false,
      email: null,
      first_name: null,
      last_name: null,
      valid: true
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    }
  },
  mounted() {
    this.getReferralCodes();
  },
  methods: {
    getNameFromUser,
    getReferralCodes() {
      let getCodes = fbfunctions.httpsCallable('getReferralCodes');
      getCodes({ limit: 9999 })
        .then(res => {
          this.referralCodes = res.data.data;
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading referral codes: ${error}`
          });
        });
    },
    generateReferralCode() {
      if (this.$refs.form.validate()) {
        let payload = {
          email: this.email
        };
        if (this.first_name) payload.first_name = this.first_name;
        if (this.last_name) payload.last_name = this.last_name;

        this.loadingGenerate = true;
        let generateCode = fbfunctions.httpsCallable('generateReferralCode');
        generateCode(payload)
          .then(res => {
            this.generateDialog = false;
            this.loadingGenerate = false;
            this.referralCodes.unshift(res.data);
            this.$store.dispatch('createSnackbar', {
              color: 'success',
              text: `New referral code successfully: ${res.data.id}`
            });
          })
          .catch(error => {
            this.loadingGenerate = false;
            this.$store.dispatch('createSnackbar', {
              color: 'error',
              text: `Error generating referral code: ${error}`
            });
          });
      } else {
        this.loadingGenerate = false;
      }
    }
  }
};
</script>

<style lang="scss">
.referral-codes__status {
  cursor: default;
}
</style>
